import { useFormContext, Controller } from 'react-hook-form';
import { InputHTMLAttributes } from 'react';

export interface TextProps extends InputHTMLAttributes<HTMLInputElement> {
    type: string;
    value?: string;
    placeholder?: string;
    onChange?: any;
    disabled?: boolean;
    isIconShow?: boolean;
    autoFocus?: boolean;
    className?: string;
    // IconName?: keyof typeof HeroIcons;
    onPasswordIconClick?: (hidden: boolean) => void;
    min?: any;
    IconComponent?: any;
    IconComponentClassName?: string;
    control?: any;
    name?: string;
}
export default function TextInput({ type, value, placeholder, onChange, disabled = false, isIconShow = false, autoFocus, className, IconComponent, IconComponentClassName, min, name, ...rest }: TextProps) {
    const formContext = useFormContext();
    const control = formContext?.control || rest?.control;

    const inputProps = { ...rest }

    delete inputProps.onPasswordIconClick

    if (!control) {
        // If not using react-hook-form, fallback to controlled textinput
        return (
            <div className="relative">
                <div
                    className="absolute inset-y-0 left-2 flex items-center pr-3 text-gray-500"
                >
                    {IconComponent && (
                        <img src={IconComponent} alt="" className={IconComponentClassName} />
                    )}
                </div>
                <input
                    type={type}
                    value={value}
                    placeholder={placeholder}
                    onChange={onChange}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    className={`py-2 input input-md h-11 shadow-shadowAll w-full rounded-basicRadius outline-[5] focus:outline-primary px-2 ${IconComponent ? 'pl-9' : 'pl-0'} bg-white border border-feildBorder font-aeonikReg text-sm ${className}`}
                    min={min}
                    {...inputProps}
                />
            </div>
        );
    }

    return (
        <Controller
            name={name || ""}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <div className="relative">
                    <div
                        className="absolute inset-y-0 left-2 flex items-center pr-3 text-gray-500"
                    >
                        {IconComponent && (
                            <img src={IconComponent} alt="" className={IconComponentClassName} />
                        )}
                    </div>
                    <input
                        {...field}
                        type={type}
                        placeholder={placeholder}
                        disabled={disabled}
                        autoFocus={autoFocus}
                        className={`py-2 input input-md h-11 shadow-shadowAll w-full rounded-basicRadius outline-[5] focus:outline-primary px-2 ${IconComponent ? 'pl-9' : 'pl-0'} bg-white border border-feildBorder font-aeonikReg text-sm ${className}`}
                        min={min}
                        {...inputProps}
                    />
                    {error && <span className="text-sm text-rejectDark">{error.message}</span>}
                </div>
            )}
        />
    )
}